var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_965",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6667C7.07778 14.6667 6.21111 14.4917 5.4 14.1417C4.58889 13.7917 3.88334 13.3167 3.28334 12.7167C2.68334 12.1167 2.20834 11.4111 1.85834 10.6C1.50834 9.7889 1.33334 8.92223 1.33334 8.00001C1.33334 7.06668 1.50834 6.19723 1.85834 5.39168C2.20834 4.58612 2.68334 3.88334 3.28334 3.28334L4.21667 4.21668C3.72778 4.70557 3.34722 5.27223 3.075 5.91668C2.80278 6.56112 2.66667 7.25557 2.66667 8.00001C2.66667 9.4889 3.18334 10.75 4.21667 11.7833C5.25 12.8167 6.51111 13.3333 8 13.3333C9.48889 13.3333 10.75 12.8167 11.7833 11.7833C12.8167 10.75 13.3333 9.4889 13.3333 8.00001C13.3333 7.25557 13.1972 6.56112 12.925 5.91668C12.6528 5.27223 12.2722 4.70557 11.7833 4.21668L12.7167 3.28334C13.3167 3.88334 13.7917 4.58612 14.1417 5.39168C14.4917 6.19723 14.6667 7.06668 14.6667 8.00001C14.6667 8.92223 14.4917 9.7889 14.1417 10.6C13.7917 11.4111 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4111 13.7917 10.6 14.1417C9.78889 14.4917 8.92222 14.6667 8 14.6667ZM7.33334 8.66668V1.33334H8.66667V8.66668H7.33334Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/LogOutIcon.ee0b7fe2a5cdbed5094ee913aa389624.svg";
export { ForwardRef as ReactComponent };